<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import SendingProfilesComponent from './SendingProfilesComponent.vue';

    export default {
    name: 'SendingProfilesPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, SendingProfilesComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <SendingProfilesComponent />
        </body>   
   
</template>
  
<style lang="css">

</style>